export default "__VITE_ASSET__DX5Nz9gd__"